// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* リセットとベーススタイル */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f7fa;
  color: #333;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ヘッダー */
.app-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1rem 2rem;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.app-header h1 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.app-header p {
  font-size: 1rem;
  margin: 0.5rem 0 0 0;
  opacity: 0.9;
}

.current-tournament {
  font-size: 0.9rem;
  margin-top: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  display: inline-block;
}

/* タブナビゲーション */
.tab-navigation {
  background: white;
  display: flex;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  border-bottom: 1px solid #e1e5e9;
}

.tab-button {
  background: none;
  border: none;
  padding: 1rem 1.5rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  min-width: 120px;
}

.tab-button:hover {
  background-color: #f8f9fa;
}

.tab-button.active {
  background-color: #f8f9fa;
  border-bottom-color: #667eea;
  color: #667eea;
}

.tab-icon {
  font-size: 1.5rem;
}

.tab-label {
  font-size: 0.9rem;
  font-weight: 500;
}

/* メインコンテンツ */
.main-content {
  flex: 1 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* セクションヘッダー */
.section-header {
  text-align: center;
  margin-bottom: 2rem;
}

.section-header h2 {
  font-size: 2rem;
  color: #2d3748;
  margin-bottom: 0.5rem;
}

.section-header p {
  color: #718096;
  font-size: 1.1rem;
}

.scoring-info {
  margin-top: 1rem;
  padding: 1rem;
  background: #f7fafc;
  border-radius: 8px;
  border-left: 4px solid #667eea;
}

.scoring-rule {
  color: #4a5568;
  font-size: 0.95rem;
  line-height: 1.6;
}

/* 空の状態 */
.empty-state {
  text-align: center;
  padding: 3rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.empty-state p {
  color: #718096;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

/* チーム管理スタイル */
.team-management, .player-management {
  max-width: 800px;
  margin: 0 auto;
}

.add-team-form, .add-player-form {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
}

.form-group {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.team-input, .player-input {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.team-input:focus, .player-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.add-button {
  background: #667eea;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.add-button:hover:not(:disabled) {
  background: #5a67d8;
}

.add-button:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
}

.teams-list, .players-list {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
  margin-bottom: 2rem;
}

.list-header h3 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.teams-grid, .players-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}

.team-card, .player-card {
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.3s ease;
}

.team-card:hover, .player-card:hover {
  border-color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.team-number, .player-number {
  font-size: 0.8rem;
  color: #718096;
  margin-bottom: 0.5rem;
}

.team-info, .player-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.team-name, .player-name {
  font-weight: 600;
  color: #2d3748;
}

.team-actions, .player-actions {
  display: flex;
  gap: 0.5rem;
}

.edit-button, .delete-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.edit-button:hover {
  background: #e2e8f0;
}

.delete-button:hover {
  background: #fed7d7;
}

.edit-form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.edit-input {
  padding: 0.5rem;
  border: 2px solid #667eea;
  border-radius: 4px;
  font-size: 1rem;
}

.edit-buttons {
  display: flex;
  gap: 0.5rem;
}

.save-button, .cancel-button {
  flex: 1 1;
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.save-button {
  background: #48bb78;
  color: white;
}

.cancel-button {
  background: #e53e3e;
  color: white;
}

.team-stats, .player-stats {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
  margin-bottom: 2rem;
}

.stats-card h4 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e2e8f0;
}

.stat-label {
  color: #718096;
}

.stat-value {
  font-weight: 600;
  color: #2d3748;
}

/* ゲーム説明 */
.game-explanation {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
}

.explanation-card h4 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.explanation-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.game-format h5, .scoring-system h5 {
  color: #667eea;
  margin-bottom: 0.5rem;
}

.game-format ul, .scoring-system ul {
  list-style-type: none;
  padding: 0;
}

.game-format li, .scoring-system li {
  padding: 0.25rem 0;
  color: #4a5568;
}

.game-format li:before, .scoring-system li:before {
  content: "• ";
  color: #667eea;
  font-weight: bold;
}

/* 大会管理スタイル */
.tournament-management {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
  margin-bottom: 2rem;
}

.tournament-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.tournament-header h3 {
  color: #2d3748;
  margin: 0;
}

.add-tournament-form {
  background: #f7fafc;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.tournaments-list h4 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.tournaments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.tournament-card {
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  transition: all 0.3s ease;
}

.tournament-card:hover {
  border-color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.tournament-card.active {
  border-color: #667eea;
  background: #ebf4ff;
}

.tournament-info {
  margin-bottom: 1rem;
}

.tournament-name {
  font-weight: 600;
  color: #2d3748;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

.tournament-date {
  color: #718096;
  font-size: 0.9rem;
}

.tournament-actions {
  display: flex;
  gap: 0.5rem;
}

.select-button {
  flex: 1 1;
  padding: 0.5rem 1rem;
  border: 2px solid #667eea;
  border-radius: 6px;
  background: white;
  color: #667eea;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.select-button:hover {
  background: #667eea;
  color: white;
}

.select-button.selected {
  background: #667eea;
  color: white;
}

.tournament-notice {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.tournament-notice p {
  color: #856404;
  margin: 0;
}

.team-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
  margin-bottom: 2rem;
}

.section-divider {
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 1rem;
  margin-bottom: 2rem;
}

.section-divider h3 {
  color: #2d3748;
  margin: 0 0 0.5rem 0;
}

.current-tournament-info {
  color: #667eea;
  font-size: 0.9rem;
  margin: 0;
}

.form-notice {
  color: #718096;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  font-style: italic;
}

.section-description {
  color: #718096;
  font-size: 0.9rem;
  margin: 0;
}

/* 選手管理スタイル */
.players-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
  margin-bottom: 2rem;
  border-left: 4px solid #48bb78;
}

.close-button {
  background: #e53e3e;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.close-button:hover {
  background: #c53030;
}

.add-player-form {
  background: #f7fafc;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 2rem;
}

.player-input {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.player-input:focus {
  outline: none;
  border-color: #48bb78;
  box-shadow: 0 0 0 3px rgba(72, 187, 120, 0.1);
}

.role-select {
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.role-select:focus {
  outline: none;
  border-color: #48bb78;
  box-shadow: 0 0 0 3px rgba(72, 187, 120, 0.1);
}

.players-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
}

.player-card {
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.3s ease;
}

.player-card:hover {
  border-color: #48bb78;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.player-number {
  font-size: 0.8rem;
  color: #718096;
  margin-bottom: 0.5rem;
}

.player-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.player-name {
  font-weight: 600;
  color: #2d3748;
  font-size: 1.1rem;
}

.player-role {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  width: fit-content;
}

.player-role.サバイバー {
  background: #c6f6d5;
  color: #2f855a;
}

.player-role.ハンター {
  background: #fed7d7;
  color: #c53030;
}

.player-role.オールラウンド {
  background: #e2e8f0;
  color: #4a5568;
}

.player-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.players-button {
  background: #48bb78;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.players-button:hover {
  background: #38a169;
}

.team-players-count {
  color: #718096;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.current-tournament-info {
  background: #ebf4ff;
  border: 1px solid #bee3f8;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.current-tournament-info p {
  color: #2b6cb0;
  margin: 0.25rem 0;
}

/* 試合順序設定スタイル */
.matches-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.order-button {
  background: #667eea;
  color: white;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.order-button:hover {
  background: #5a67d8;
}

.match-order-panel {
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e2e8f0;
}

.order-header h4 {
  color: #2d3748;
  margin: 0;
}

.order-actions {
  display: flex;
  gap: 0.5rem;
}

.reset-order-button {
  background: #ed8936;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.reset-order-button:hover {
  background: #dd6b20;
}

.close-order-button {
  background: #e53e3e;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.close-order-button:hover {
  background: #c53030;
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.order-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.match-teams {
  font-weight: 600;
  color: #2d3748;
}

.order-control {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.order-control label {
  color: #4a5568;
  font-weight: 600;
  font-size: 0.9rem;
}

.order-input {
  width: 60px;
  padding: 0.5rem;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  text-align: center;
  font-weight: 600;
}

.order-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* 総当たり戦・トーナメント共通スタイル */
.round-robin, .tournament, .statistics {
  max-width: 1200px;
  margin: 0 auto;
}

.progress-section {
  margin-bottom: 2rem;
}

.progress-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.progress-card h3 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.progress-bar {
  background: #e2e8f0;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-fill {
  background: linear-gradient(90deg, #667eea, #764ba2);
  height: 100%;
  transition: width 0.3s ease;
}

.progress-text {
  color: #718096;
  font-size: 0.9rem;
}

/* 試合関連スタイル */
.matches-section, .bracket-section {
  margin-bottom: 2rem;
}

.matches-section h3, .bracket-section h3 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.matches-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}

.match-card, .tournament-match {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 1.5rem;
  transition: transform 0.3s ease;
  margin-bottom: 1rem;
}

.match-card:hover, .tournament-match:hover {
  transform: translateY(-2px);
}

.match-header, .match-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.match-number, .match-title {
  font-weight: 600;
  color: #2d3748;
}

.match-status.completed {
  color: #48bb78;
  font-size: 0.9rem;
}

.player-vs, .match-players {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.vs, .vs-divider {
  color: #718096;
  font-weight: 700;
}

.match-actions, .tournament-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.result-button, .tournament-result-button {
  padding: 0.75rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  background: #667eea;
  color: white;
}

.result-button:hover, .tournament-result-button:hover {
  background: #5a67d8;
}

.win-button {
  background: #48bb78;
}

.win-button:hover {
  background: #38a169;
}

.draw-button {
  background: #ed8936;
}

.draw-button:hover {
  background: #dd6b20;
}

.match-result, .tournament-result {
  text-align: center;
}

.result-display {
  margin-bottom: 1rem;
}

.winner {
  color: #48bb78;
  font-weight: 600;
}

.draw {
  color: #ed8936;
  font-weight: 600;
}

.clear-button, .clear-result-button {
  background: #e53e3e;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
}

.clear-button:hover, .clear-result-button:hover {
  background: #c53030;
}

/* 順位表・統計テーブル */
.standings-section, .player-rankings-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
  margin-bottom: 2rem;
}

.standings-section h3, .player-rankings-section h3 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.standings-table, .rankings-table {
  display: grid;
  gap: 0.5rem;
}

.table-header {
  display: grid;
  grid-template-columns: 60px 1fr 120px 80px 80px 80px 80px 80px;
  gap: 1rem;
  padding: 1rem;
  background: #f7fafc;
  border-radius: 8px;
  font-weight: 600;
  color: #2d3748;
  font-size: 0.9rem;
}

.table-row {
  display: grid;
  grid-template-columns: 60px 1fr 120px 80px 80px 80px 80px 80px;
  gap: 1rem;
  padding: 1rem;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.table-row:hover {
  background: #f7fafc;
  border-color: #667eea;
}

.table-row.selected {
  background: #ebf4ff;
  border-color: #667eea;
}

.rank {
  font-weight: 600;
}

.rank-1 { color: #d69e2e; }
.rank-2 { color: #718096; }
.rank-3 { color: #cd7c2f; }

/* トーナメント特有のスタイル */
.champion-section {
  margin-bottom: 2rem;
}

.champion-card {
  background: linear-gradient(135deg, #ffd700, #ffed4e);
  color: #2d3748;
  padding: 2rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(255, 215, 0, 0.3);
}

.champion-card h3 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.champion-name {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.champion-trophy {
  font-size: 3rem;
}

.qualified-section {
  margin-bottom: 2rem;
}

.qualified-section h3 {
  color: #2d3748;
  margin-bottom: 0.5rem;
}

.qualified-info {
  color: #718096;
  margin-bottom: 1rem;
}

.qualified-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.qualified-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  transition: all 0.3s ease;
}

.qualified-card:hover {
  border-color: #667eea;
  transform: translateY(-2px);
}

.qualified-rank {
  font-size: 0.8rem;
  color: #718096;
  margin-bottom: 0.5rem;
}

.qualified-name {
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0.5rem;
}

.qualified-stats {
  font-size: 0.9rem;
  color: #718096;
}

.tournament-controls {
  text-align: center;
  margin-bottom: 2rem;
}

.start-tournament-button, .reset-tournament-button {
  background: #667eea;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.start-tournament-button:hover:not(:disabled) {
  background: #5a67d8;
}

.start-tournament-button:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
}

.reset-tournament-button {
  background: #e53e3e;
}

.reset-tournament-button:hover {
  background: #c53030;
}

.bracket-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.tournament-round {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
}

.round-header h4 {
  color: #2d3748;
  margin-bottom: 1rem;
  text-align: center;
  font-size: 1.3rem;
}

.round-matches {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}

/* 統計画面特有のスタイル */
.overall-stats-section {
  margin-bottom: 2rem;
}

.overall-stats-section h3 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.stat-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.stat-icon {
  font-size: 2rem;
}

.stat-info {
  flex: 1 1;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 0.25rem;
}

.stat-label {
  color: #718096;
  font-size: 0.9rem;
}

.stat-status {
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

.player-detail-section {
  margin-top: 2rem;
}

.player-detail-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e2e8f0;
}

.detail-header h3 {
  color: #2d3748;
}

.detail-rank {
  color: #667eea;
  font-weight: 600;
}

.detail-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.detail-section h4 {
  color: #2d3748;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.detail-stats {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.detail-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-stat .label {
  color: #718096;
}

.detail-stat .value {
  font-weight: 600;
  color: #2d3748;
}

/* レスポンシブデザイン */
@media (max-width: 768px) {
  .main-content {
    padding: 1rem;
  }
  
  .tab-navigation {
    flex-wrap: wrap;
  }
  
  .tab-button {
    min-width: 100px;
    padding: 0.75rem 1rem;
  }
  
  .form-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .table-header, .table-row {
    grid-template-columns: 50px 1fr 100px 60px 60px 60px 60px 60px;
    gap: 0.5rem;
    padding: 0.75rem;
    font-size: 0.8rem;
  }
  
  .matches-grid, .round-matches {
    grid-template-columns: 1fr;
  }
  
  .detail-stats-grid {
    grid-template-columns: 1fr;
  }
}

/* 非対称戦特有のスタイル */
.asymmetric-matches {
  max-width: 1200px;
  margin: 0 auto;
}

.asymmetric-match-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
  margin-bottom: 1.5rem;
  transition: transform 0.3s ease;
}

.asymmetric-match-card:hover {
  transform: translateY(-2px);
}

.half-match {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.half-match h4 {
  color: #2d3748;
  margin-bottom: 1rem;
  text-align: center;
}

.match-setup {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 1rem;
  align-items: center;
}

.hunter-side, .survivor-side {
  text-align: center;
}

.role-label {
  font-size: 0.9rem;
  color: #718096;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.team-name.hunter {
  background: #e53e3e;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 600;
  margin: 0.25rem 0;
}

.team-name.survivor {
  background: #48bb78;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 600;
  margin: 0.25rem 0;
}

.survivor-teams {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.result-form {
  background: #f7fafc;
  padding: 1.5rem;
  border-radius: 8px;
  margin-top: 1rem;
}

.team-vs-team {
  margin: 1rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.team-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}

.team-display .team-name {
  background: #667eea;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.1rem;
}

.hunter-selection, .kill-count-selection {
  margin-bottom: 1rem;
}

.hunter-selection label, .kill-count-selection label {
  display: block;
  color: #2d3748;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.team-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-bottom: 1rem;
}

.team-button {
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  background: white;
  color: #4a5568;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.team-button:hover {
  border-color: #667eea;
  background: #f7fafc;
}

.team-button.selected {
  background: #667eea;
  color: white;
  border-color: #5a67d8;
}

.kill-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.kill-button {
  padding: 0.5rem 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  background: white;
  color: #4a5568;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.kill-button:hover {
  border-color: #667eea;
  background: #f7fafc;
}

.kill-button.selected {
  background: #667eea;
  color: white;
  border-color: #5a67d8;
}

.result-details {
  font-size: 0.9rem;
  color: #4a5568;
  margin-top: 0.25rem;
  line-height: 1.4;
}

.half-result-selection {
  margin-bottom: 1.5rem;
}

.half-result-selection h5 {
  color: #2d3748;
  margin-bottom: 0.75rem;
  text-align: center;
}

.result-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.result-button {
  padding: 0.75rem 1rem;
  border: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  background: #e2e8f0;
  color: #4a5568;
}

.hunter-button {
  background: #fed7d7;
  color: #c53030;
}

.hunter-button.selected {
  background: #e53e3e;
  color: white;
  border-color: #c53030;
}

.survivor-button {
  background: #c6f6d5;
  color: #2f855a;
}

.survivor-button.selected {
  background: #48bb78;
  color: white;
  border-color: #38a169;
}

.submit-result-button {
  width: 100%;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.submit-result-button.enabled {
  background: #667eea;
  color: white;
}

.submit-result-button.enabled:hover {
  background: #5a67d8;
}

.submit-result-button.disabled {
  background: #e2e8f0;
  color: #a0aec0;
  cursor: not-allowed;
}

.half-result {
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  background: #f7fafc;
  border-radius: 4px;
}

/* 非対称戦順位表 */
.asymmetric-standings-table .table-header {
  grid-template-columns: 60px 1fr 100px 120px 120px 80px 100px;
}

.asymmetric-standings-table .table-row {
  grid-template-columns: 60px 1fr 100px 120px 120px 80px 100px;
}

.win-rate {
  font-size: 0.8rem;
  color: #718096;
  margin-left: 0.25rem;
}

/* チーム統計特有のスタイル */
.team-statistics, .team-detail-section {
  max-width: 1200px;
  margin: 0 auto;
}

.team-rankings-section .table-header {
  grid-template-columns: 60px 1fr 100px 120px 120px 80px 80px;
}

.team-rankings-section .table-row {
  grid-template-columns: 60px 1fr 100px 120px 120px 80px 80px;
}

.team-detail-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 2rem;
  margin-top: 2rem;
}

.performance-analysis {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid #e2e8f0;
}

.performance-analysis h4 {
  color: #2d3748;
  margin-bottom: 1rem;
  text-align: center;
}

.performance-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.performance-card {
  background: #f7fafc;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}

.performance-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.hunter-performance {
  border-color: #fed7d7;
}

.hunter-performance:hover {
  border-color: #e53e3e;
}

.survivor-performance {
  border-color: #c6f6d5;
}

.survivor-performance:hover {
  border-color: #48bb78;
}

.performance-card h5 {
  color: #2d3748;
  margin-bottom: 1rem;
}

.performance-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.score-value {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
}

.score-label {
  font-size: 0.9rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-weight: 600;
}

.no-data {
  color: #a0aec0;
  font-style: italic;
}

@media (max-width: 768px) {
  .match-setup {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .vs-divider {
    text-align: center;
    font-size: 1.2rem;
  }
  
  .result-buttons {
    flex-direction: column;
  }
  
  .asymmetric-standings-table .table-header,
  .asymmetric-standings-table .table-row,
  .team-rankings-section .table-header,
  .team-rankings-section .table-row {
    grid-template-columns: 40px 1fr 80px 100px 100px 60px 80px;
    gap: 0.25rem;
    padding: 0.5rem;
    font-size: 0.8rem;
  }
  
  .performance-grid {
    grid-template-columns: 1fr;
  }
}

/* BO3/BO5形式特有のスタイル */
.bo-result-form {
  background: #f7fafc;
  padding: 2rem;
  border-radius: 12px;
  margin-top: 1rem;
}

.format-selection {
  margin-bottom: 2rem;
  text-align: center;
}

.format-selection label {
  display: block;
  color: #2d3748;
  font-weight: 600;
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.format-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.format-button {
  padding: 0.75rem 1.5rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #4a5568;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.format-button:hover {
  border-color: #667eea;
  background: #f7fafc;
}

.format-button.selected {
  background: #667eea;
  color: white;
  border-color: #5a67d8;
  box-shadow: 0 2px 10px rgba(102, 126, 234, 0.3);
}

.games-progress {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: white;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
}

.games-progress h4 {
  color: #2d3748;
  margin-bottom: 1rem;
  text-align: center;
}

.games-status {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.game-status {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  min-width: 100px;
  transition: all 0.3s ease;
}

.game-status.completed {
  background: #c6f6d5;
  color: #2f855a;
  border: 2px solid #48bb78;
}

.game-status.current {
  background: #bee3f8;
  color: #2b6cb0;
  border: 2px solid #4299e1;
  animation: pulse 2s infinite;
}

.game-status.pending {
  background: #e2e8f0;
  color: #718096;
  border: 2px solid #cbd5e0;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.current-game-form {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  border: 2px solid #4299e1;
  margin-bottom: 2rem;
}

.current-game-form h4 {
  color: #2d3748;
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 1.2rem;
}

.complete-game-button {
  width: 100%;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1.5rem;
}

.complete-game-button.enabled {
  background: #4299e1;
  color: white;
}

.complete-game-button.enabled:hover {
  background: #3182ce;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(66, 153, 225, 0.3);
}

.complete-game-button.disabled {
  background: #e2e8f0;
  color: #a0aec0;
  cursor: not-allowed;
}

.match-complete {
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, #c6f6d5, #9ae6b4);
  border-radius: 12px;
  border: 2px solid #48bb78;
}

.match-complete h4 {
  color: #2f855a;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
}

.submit-match-button {
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #48bb78;
  color: white;
}

.submit-match-button:hover {
  background: #38a169;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(72, 187, 120, 0.3);
}

.match-winner {
  text-align: center;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #ffd700, #ffed4e);
  border-radius: 12px;
  border: 2px solid #d69e2e;
}

.match-winner h4 {
  color: #2d3748;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
}

.score-summary {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2d3748;
}

.games-results {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.game-result {
  background: #f7fafc;
  border-radius: 8px;
  padding: 1.5rem;
  border: 1px solid #e2e8f0;
}

.game-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.game-header strong {
  color: #2d3748;
  font-size: 1.1rem;
}

.game-winner {
  color: #48bb78;
  font-weight: 600;
  font-size: 0.9rem;
}

.half-results {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.half-result {
  background: white;
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.half-result strong {
  color: #2d3748;
  display: block;
  margin-bottom: 0.5rem;
}

/* 順位表の更新 */
.match-record-col, .game-record-col, .winrate-col {
  text-align: center;
}

.asymmetric-standings-table .table-header {
  grid-template-columns: 60px 1fr 100px 100px 100px 80px;
}

.asymmetric-standings-table .table-row {
  grid-template-columns: 60px 1fr 100px 100px 100px 80px;
}

@media (max-width: 768px) {
  .format-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .format-button {
    width: 200px;
  }
  
  .games-status {
    flex-direction: column;
    align-items: center;
  }
  
  .game-status {
    width: 150px;
  }
  
  .half-results {
    grid-template-columns: 1fr;
  }
  
  .asymmetric-standings-table .table-header,
  .asymmetric-standings-table .table-row {
    grid-template-columns: 40px 1fr 80px 80px 80px 60px;
    gap: 0.25rem;
    padding: 0.5rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .app-header h1 {
    font-size: 1.5rem;
  }
  
  .section-header h2 {
    font-size: 1.5rem;
  }
  
  .champion-name {
    font-size: 1.5rem;
  }
  
  .champion-trophy {
    font-size: 2rem;
  }
  
  .half-match {
    padding: 0.75rem;
  }
  
  .team-name.hunter,
  .team-name.survivor {
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
  }
  
  .bo-result-form {
    padding: 1rem;
  }
  
  .current-game-form {
    padding: 1rem;
  }
  
  .games-progress {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU,cAAc,EAAE;AAC1B,UAAU,cAAc,EAAE;AAC1B,UAAU,cAAc,EAAE;;AAE1B,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,8DAA8D;IAC9D,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;IAIE,0DAA0D;IAC1D,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qDAAqD;EACrD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,mDAAmD;IACnD,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* リセットとベーススタイル */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f7fa;\n  color: #333;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ヘッダー */\n.app-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 1rem 2rem;\n  text-align: center;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.app-header h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.app-header p {\n  font-size: 1rem;\n  margin: 0.5rem 0 0 0;\n  opacity: 0.9;\n}\n\n.current-tournament {\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 20px;\n  display: inline-block;\n}\n\n/* タブナビゲーション */\n.tab-navigation {\n  background: white;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n  border-bottom: 1px solid #e1e5e9;\n}\n\n.tab-button {\n  background: none;\n  border: none;\n  padding: 1rem 1.5rem;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n  min-width: 120px;\n}\n\n.tab-button:hover {\n  background-color: #f8f9fa;\n}\n\n.tab-button.active {\n  background-color: #f8f9fa;\n  border-bottom-color: #667eea;\n  color: #667eea;\n}\n\n.tab-icon {\n  font-size: 1.5rem;\n}\n\n.tab-label {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* メインコンテンツ */\n.main-content {\n  flex: 1;\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* セクションヘッダー */\n.section-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.section-header h2 {\n  font-size: 2rem;\n  color: #2d3748;\n  margin-bottom: 0.5rem;\n}\n\n.section-header p {\n  color: #718096;\n  font-size: 1.1rem;\n}\n\n.scoring-info {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #f7fafc;\n  border-radius: 8px;\n  border-left: 4px solid #667eea;\n}\n\n.scoring-rule {\n  color: #4a5568;\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n/* 空の状態 */\n.empty-state {\n  text-align: center;\n  padding: 3rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.empty-state p {\n  color: #718096;\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n}\n\n/* チーム管理スタイル */\n.team-management, .player-management {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.add-team-form, .add-player-form {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  margin-bottom: 2rem;\n}\n\n.form-group {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.team-input, .player-input {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n}\n\n.team-input:focus, .player-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.add-button {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.add-button:hover:not(:disabled) {\n  background: #5a67d8;\n}\n\n.add-button:disabled {\n  background: #cbd5e0;\n  cursor: not-allowed;\n}\n\n.teams-list, .players-list {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.list-header h3 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.teams-grid, .players-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.team-card, .player-card {\n  background: #f7fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1rem;\n  transition: all 0.3s ease;\n}\n\n.team-card:hover, .player-card:hover {\n  border-color: #667eea;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n}\n\n.team-number, .player-number {\n  font-size: 0.8rem;\n  color: #718096;\n  margin-bottom: 0.5rem;\n}\n\n.team-info, .player-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.team-name, .player-name {\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.team-actions, .player-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.edit-button, .delete-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n}\n\n.edit-button:hover {\n  background: #e2e8f0;\n}\n\n.delete-button:hover {\n  background: #fed7d7;\n}\n\n.edit-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.edit-input {\n  padding: 0.5rem;\n  border: 2px solid #667eea;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.edit-buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.save-button, .cancel-button {\n  flex: 1;\n  padding: 0.5rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.save-button {\n  background: #48bb78;\n  color: white;\n}\n\n.cancel-button {\n  background: #e53e3e;\n  color: white;\n}\n\n.team-stats, .player-stats {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.stats-card h4 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.stat-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.stat-label {\n  color: #718096;\n}\n\n.stat-value {\n  font-weight: 600;\n  color: #2d3748;\n}\n\n/* ゲーム説明 */\n.game-explanation {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n}\n\n.explanation-card h4 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.explanation-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.game-format h5, .scoring-system h5 {\n  color: #667eea;\n  margin-bottom: 0.5rem;\n}\n\n.game-format ul, .scoring-system ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.game-format li, .scoring-system li {\n  padding: 0.25rem 0;\n  color: #4a5568;\n}\n\n.game-format li:before, .scoring-system li:before {\n  content: \"• \";\n  color: #667eea;\n  font-weight: bold;\n}\n\n/* 大会管理スタイル */\n.tournament-management {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.tournament-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.tournament-header h3 {\n  color: #2d3748;\n  margin: 0;\n}\n\n.add-tournament-form {\n  background: #f7fafc;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n}\n\n.tournaments-list h4 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.tournaments-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.tournament-card {\n  background: #f7fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.tournament-card:hover {\n  border-color: #667eea;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n}\n\n.tournament-card.active {\n  border-color: #667eea;\n  background: #ebf4ff;\n}\n\n.tournament-info {\n  margin-bottom: 1rem;\n}\n\n.tournament-name {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n}\n\n.tournament-date {\n  color: #718096;\n  font-size: 0.9rem;\n}\n\n.tournament-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.select-button {\n  flex: 1;\n  padding: 0.5rem 1rem;\n  border: 2px solid #667eea;\n  border-radius: 6px;\n  background: white;\n  color: #667eea;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.select-button:hover {\n  background: #667eea;\n  color: white;\n}\n\n.select-button.selected {\n  background: #667eea;\n  color: white;\n}\n\n.tournament-notice {\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 1rem;\n}\n\n.tournament-notice p {\n  color: #856404;\n  margin: 0;\n}\n\n.team-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.section-divider {\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 1rem;\n  margin-bottom: 2rem;\n}\n\n.section-divider h3 {\n  color: #2d3748;\n  margin: 0 0 0.5rem 0;\n}\n\n.current-tournament-info {\n  color: #667eea;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.form-notice {\n  color: #718096;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n  font-style: italic;\n}\n\n.section-description {\n  color: #718096;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* 選手管理スタイル */\n.players-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n  margin-bottom: 2rem;\n  border-left: 4px solid #48bb78;\n}\n\n.close-button {\n  background: #e53e3e;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n}\n\n.close-button:hover {\n  background: #c53030;\n}\n\n.add-player-form {\n  background: #f7fafc;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 2rem;\n}\n\n.player-input {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n}\n\n.player-input:focus {\n  outline: none;\n  border-color: #48bb78;\n  box-shadow: 0 0 0 3px rgba(72, 187, 120, 0.1);\n}\n\n.role-select {\n  padding: 0.75rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n}\n\n.role-select:focus {\n  outline: none;\n  border-color: #48bb78;\n  box-shadow: 0 0 0 3px rgba(72, 187, 120, 0.1);\n}\n\n.players-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1rem;\n}\n\n.player-card {\n  background: #f7fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1rem;\n  transition: all 0.3s ease;\n}\n\n.player-card:hover {\n  border-color: #48bb78;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n}\n\n.player-number {\n  font-size: 0.8rem;\n  color: #718096;\n  margin-bottom: 0.5rem;\n}\n\n.player-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.player-name {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 1.1rem;\n}\n\n.player-role {\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-align: center;\n  width: fit-content;\n}\n\n.player-role.サバイバー {\n  background: #c6f6d5;\n  color: #2f855a;\n}\n\n.player-role.ハンター {\n  background: #fed7d7;\n  color: #c53030;\n}\n\n.player-role.オールラウンド {\n  background: #e2e8f0;\n  color: #4a5568;\n}\n\n.player-actions {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.players-button {\n  background: #48bb78;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n}\n\n.players-button:hover {\n  background: #38a169;\n}\n\n.team-players-count {\n  color: #718096;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n}\n\n.current-tournament-info {\n  background: #ebf4ff;\n  border: 1px solid #bee3f8;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 1rem;\n}\n\n.current-tournament-info p {\n  color: #2b6cb0;\n  margin: 0.25rem 0;\n}\n\n/* 試合順序設定スタイル */\n.matches-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.order-button {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n}\n\n.order-button:hover {\n  background: #5a67d8;\n}\n\n.match-order-panel {\n  background: #f7fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.order-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.order-header h4 {\n  color: #2d3748;\n  margin: 0;\n}\n\n.order-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.reset-order-button {\n  background: #ed8936;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n}\n\n.reset-order-button:hover {\n  background: #dd6b20;\n}\n\n.close-order-button {\n  background: #e53e3e;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n}\n\n.close-order-button:hover {\n  background: #c53030;\n}\n\n.order-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.order-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: white;\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.match-teams {\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.order-control {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.order-control label {\n  color: #4a5568;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.order-input {\n  width: 60px;\n  padding: 0.5rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  text-align: center;\n  font-weight: 600;\n}\n\n.order-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n/* 総当たり戦・トーナメント共通スタイル */\n.round-robin, .tournament, .statistics {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.progress-section {\n  margin-bottom: 2rem;\n}\n\n.progress-card {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.progress-card h3 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.progress-bar {\n  background: #e2e8f0;\n  height: 8px;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.progress-fill {\n  background: linear-gradient(90deg, #667eea, #764ba2);\n  height: 100%;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  color: #718096;\n  font-size: 0.9rem;\n}\n\n/* 試合関連スタイル */\n.matches-section, .bracket-section {\n  margin-bottom: 2rem;\n}\n\n.matches-section h3, .bracket-section h3 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.matches-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.match-card, .tournament-match {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 1.5rem;\n  transition: transform 0.3s ease;\n  margin-bottom: 1rem;\n}\n\n.match-card:hover, .tournament-match:hover {\n  transform: translateY(-2px);\n}\n\n.match-header, .match-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.match-number, .match-title {\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.match-status.completed {\n  color: #48bb78;\n  font-size: 0.9rem;\n}\n\n.player-vs, .match-players {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.vs, .vs-divider {\n  color: #718096;\n  font-weight: 700;\n}\n\n.match-actions, .tournament-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.result-button, .tournament-result-button {\n  padding: 0.75rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  background: #667eea;\n  color: white;\n}\n\n.result-button:hover, .tournament-result-button:hover {\n  background: #5a67d8;\n}\n\n.win-button {\n  background: #48bb78;\n}\n\n.win-button:hover {\n  background: #38a169;\n}\n\n.draw-button {\n  background: #ed8936;\n}\n\n.draw-button:hover {\n  background: #dd6b20;\n}\n\n.match-result, .tournament-result {\n  text-align: center;\n}\n\n.result-display {\n  margin-bottom: 1rem;\n}\n\n.winner {\n  color: #48bb78;\n  font-weight: 600;\n}\n\n.draw {\n  color: #ed8936;\n  font-weight: 600;\n}\n\n.clear-button, .clear-result-button {\n  background: #e53e3e;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.clear-button:hover, .clear-result-button:hover {\n  background: #c53030;\n}\n\n/* 順位表・統計テーブル */\n.standings-section, .player-rankings-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.standings-section h3, .player-rankings-section h3 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.standings-table, .rankings-table {\n  display: grid;\n  gap: 0.5rem;\n}\n\n.table-header {\n  display: grid;\n  grid-template-columns: 60px 1fr 120px 80px 80px 80px 80px 80px;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f7fafc;\n  border-radius: 8px;\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 0.9rem;\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 60px 1fr 120px 80px 80px 80px 80px 80px;\n  gap: 1rem;\n  padding: 1rem;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.table-row:hover {\n  background: #f7fafc;\n  border-color: #667eea;\n}\n\n.table-row.selected {\n  background: #ebf4ff;\n  border-color: #667eea;\n}\n\n.rank {\n  font-weight: 600;\n}\n\n.rank-1 { color: #d69e2e; }\n.rank-2 { color: #718096; }\n.rank-3 { color: #cd7c2f; }\n\n/* トーナメント特有のスタイル */\n.champion-section {\n  margin-bottom: 2rem;\n}\n\n.champion-card {\n  background: linear-gradient(135deg, #ffd700, #ffed4e);\n  color: #2d3748;\n  padding: 2rem;\n  border-radius: 12px;\n  text-align: center;\n  box-shadow: 0 4px 20px rgba(255, 215, 0, 0.3);\n}\n\n.champion-card h3 {\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n}\n\n.champion-name {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n.champion-trophy {\n  font-size: 3rem;\n}\n\n.qualified-section {\n  margin-bottom: 2rem;\n}\n\n.qualified-section h3 {\n  color: #2d3748;\n  margin-bottom: 0.5rem;\n}\n\n.qualified-info {\n  color: #718096;\n  margin-bottom: 1rem;\n}\n\n.qualified-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.qualified-card {\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1rem;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.qualified-card:hover {\n  border-color: #667eea;\n  transform: translateY(-2px);\n}\n\n.qualified-rank {\n  font-size: 0.8rem;\n  color: #718096;\n  margin-bottom: 0.5rem;\n}\n\n.qualified-name {\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 0.5rem;\n}\n\n.qualified-stats {\n  font-size: 0.9rem;\n  color: #718096;\n}\n\n.tournament-controls {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.start-tournament-button, .reset-tournament-button {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.start-tournament-button:hover:not(:disabled) {\n  background: #5a67d8;\n}\n\n.start-tournament-button:disabled {\n  background: #cbd5e0;\n  cursor: not-allowed;\n}\n\n.reset-tournament-button {\n  background: #e53e3e;\n}\n\n.reset-tournament-button:hover {\n  background: #c53030;\n}\n\n.bracket-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.tournament-round {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n}\n\n.round-header h4 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n  text-align: center;\n  font-size: 1.3rem;\n}\n\n.round-matches {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n/* 統計画面特有のスタイル */\n.overall-stats-section {\n  margin-bottom: 2rem;\n}\n\n.overall-stats-section h3 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.stat-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  transition: transform 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n}\n\n.stat-icon {\n  font-size: 2rem;\n}\n\n.stat-info {\n  flex: 1;\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin-bottom: 0.25rem;\n}\n\n.stat-label {\n  color: #718096;\n  font-size: 0.9rem;\n}\n\n.stat-status {\n  font-size: 0.8rem;\n  margin-top: 0.25rem;\n}\n\n.player-detail-section {\n  margin-top: 2rem;\n}\n\n.player-detail-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n}\n\n.detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.detail-header h3 {\n  color: #2d3748;\n}\n\n.detail-rank {\n  color: #667eea;\n  font-weight: 600;\n}\n\n.detail-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n}\n\n.detail-section h4 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.detail-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.detail-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.detail-stat .label {\n  color: #718096;\n}\n\n.detail-stat .value {\n  font-weight: 600;\n  color: #2d3748;\n}\n\n/* レスポンシブデザイン */\n@media (max-width: 768px) {\n  .main-content {\n    padding: 1rem;\n  }\n  \n  .tab-navigation {\n    flex-wrap: wrap;\n  }\n  \n  .tab-button {\n    min-width: 100px;\n    padding: 0.75rem 1rem;\n  }\n  \n  .form-group {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .table-header, .table-row {\n    grid-template-columns: 50px 1fr 100px 60px 60px 60px 60px 60px;\n    gap: 0.5rem;\n    padding: 0.75rem;\n    font-size: 0.8rem;\n  }\n  \n  .matches-grid, .round-matches {\n    grid-template-columns: 1fr;\n  }\n  \n  .detail-stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* 非対称戦特有のスタイル */\n.asymmetric-matches {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.asymmetric-match-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n  margin-bottom: 1.5rem;\n  transition: transform 0.3s ease;\n}\n\n.asymmetric-match-card:hover {\n  transform: translateY(-2px);\n}\n\n.half-match {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.half-match h4 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.match-setup {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 1rem;\n  align-items: center;\n}\n\n.hunter-side, .survivor-side {\n  text-align: center;\n}\n\n.role-label {\n  font-size: 0.9rem;\n  color: #718096;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.team-name.hunter {\n  background: #e53e3e;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-weight: 600;\n  margin: 0.25rem 0;\n}\n\n.team-name.survivor {\n  background: #48bb78;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-weight: 600;\n  margin: 0.25rem 0;\n}\n\n.survivor-teams {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.result-form {\n  background: #f7fafc;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-top: 1rem;\n}\n\n.team-vs-team {\n  margin: 1rem 0;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.team-display {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n}\n\n.team-display .team-name {\n  background: #667eea;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.hunter-selection, .kill-count-selection {\n  margin-bottom: 1rem;\n}\n\n.hunter-selection label, .kill-count-selection label {\n  display: block;\n  color: #2d3748;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.team-buttons {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.team-button {\n  padding: 0.75rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  background: white;\n  color: #4a5568;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.team-button:hover {\n  border-color: #667eea;\n  background: #f7fafc;\n}\n\n.team-button.selected {\n  background: #667eea;\n  color: white;\n  border-color: #5a67d8;\n}\n\n.kill-buttons {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.kill-button {\n  padding: 0.5rem 0.75rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  background: white;\n  color: #4a5568;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n}\n\n.kill-button:hover {\n  border-color: #667eea;\n  background: #f7fafc;\n}\n\n.kill-button.selected {\n  background: #667eea;\n  color: white;\n  border-color: #5a67d8;\n}\n\n.result-details {\n  font-size: 0.9rem;\n  color: #4a5568;\n  margin-top: 0.25rem;\n  line-height: 1.4;\n}\n\n.half-result-selection {\n  margin-bottom: 1.5rem;\n}\n\n.half-result-selection h5 {\n  color: #2d3748;\n  margin-bottom: 0.75rem;\n  text-align: center;\n}\n\n.result-buttons {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.result-button {\n  padding: 0.75rem 1rem;\n  border: 2px solid transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  background: #e2e8f0;\n  color: #4a5568;\n}\n\n.hunter-button {\n  background: #fed7d7;\n  color: #c53030;\n}\n\n.hunter-button.selected {\n  background: #e53e3e;\n  color: white;\n  border-color: #c53030;\n}\n\n.survivor-button {\n  background: #c6f6d5;\n  color: #2f855a;\n}\n\n.survivor-button.selected {\n  background: #48bb78;\n  color: white;\n  border-color: #38a169;\n}\n\n.submit-result-button {\n  width: 100%;\n  padding: 1rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.submit-result-button.enabled {\n  background: #667eea;\n  color: white;\n}\n\n.submit-result-button.enabled:hover {\n  background: #5a67d8;\n}\n\n.submit-result-button.disabled {\n  background: #e2e8f0;\n  color: #a0aec0;\n  cursor: not-allowed;\n}\n\n.half-result {\n  margin-bottom: 0.5rem;\n  padding: 0.5rem;\n  background: #f7fafc;\n  border-radius: 4px;\n}\n\n/* 非対称戦順位表 */\n.asymmetric-standings-table .table-header {\n  grid-template-columns: 60px 1fr 100px 120px 120px 80px 100px;\n}\n\n.asymmetric-standings-table .table-row {\n  grid-template-columns: 60px 1fr 100px 120px 120px 80px 100px;\n}\n\n.win-rate {\n  font-size: 0.8rem;\n  color: #718096;\n  margin-left: 0.25rem;\n}\n\n/* チーム統計特有のスタイル */\n.team-statistics, .team-detail-section {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.team-rankings-section .table-header {\n  grid-template-columns: 60px 1fr 100px 120px 120px 80px 80px;\n}\n\n.team-rankings-section .table-row {\n  grid-template-columns: 60px 1fr 100px 120px 120px 80px 80px;\n}\n\n.team-detail-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 2rem;\n  margin-top: 2rem;\n}\n\n.performance-analysis {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 2px solid #e2e8f0;\n}\n\n.performance-analysis h4 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.performance-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n}\n\n.performance-card {\n  background: #f7fafc;\n  border-radius: 12px;\n  padding: 1.5rem;\n  text-align: center;\n  border: 2px solid #e2e8f0;\n  transition: all 0.3s ease;\n}\n\n.performance-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n}\n\n.hunter-performance {\n  border-color: #fed7d7;\n}\n\n.hunter-performance:hover {\n  border-color: #e53e3e;\n}\n\n.survivor-performance {\n  border-color: #c6f6d5;\n}\n\n.survivor-performance:hover {\n  border-color: #48bb78;\n}\n\n.performance-card h5 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.performance-score {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.score-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2d3748;\n}\n\n.score-label {\n  font-size: 0.9rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-weight: 600;\n}\n\n.no-data {\n  color: #a0aec0;\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .match-setup {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .vs-divider {\n    text-align: center;\n    font-size: 1.2rem;\n  }\n  \n  .result-buttons {\n    flex-direction: column;\n  }\n  \n  .asymmetric-standings-table .table-header,\n  .asymmetric-standings-table .table-row,\n  .team-rankings-section .table-header,\n  .team-rankings-section .table-row {\n    grid-template-columns: 40px 1fr 80px 100px 100px 60px 80px;\n    gap: 0.25rem;\n    padding: 0.5rem;\n    font-size: 0.8rem;\n  }\n  \n  .performance-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* BO3/BO5形式特有のスタイル */\n.bo-result-form {\n  background: #f7fafc;\n  padding: 2rem;\n  border-radius: 12px;\n  margin-top: 1rem;\n}\n\n.format-selection {\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.format-selection label {\n  display: block;\n  color: #2d3748;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n}\n\n.format-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n}\n\n.format-button {\n  padding: 0.75rem 1.5rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  background: white;\n  color: #4a5568;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n}\n\n.format-button:hover {\n  border-color: #667eea;\n  background: #f7fafc;\n}\n\n.format-button.selected {\n  background: #667eea;\n  color: white;\n  border-color: #5a67d8;\n  box-shadow: 0 2px 10px rgba(102, 126, 234, 0.3);\n}\n\n.games-progress {\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  background: white;\n  border-radius: 8px;\n  border: 2px solid #e2e8f0;\n}\n\n.games-progress h4 {\n  color: #2d3748;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.games-status {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.game-status {\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-weight: 600;\n  text-align: center;\n  min-width: 100px;\n  transition: all 0.3s ease;\n}\n\n.game-status.completed {\n  background: #c6f6d5;\n  color: #2f855a;\n  border: 2px solid #48bb78;\n}\n\n.game-status.current {\n  background: #bee3f8;\n  color: #2b6cb0;\n  border: 2px solid #4299e1;\n  animation: pulse 2s infinite;\n}\n\n.game-status.pending {\n  background: #e2e8f0;\n  color: #718096;\n  border: 2px solid #cbd5e0;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.current-game-form {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  border: 2px solid #4299e1;\n  margin-bottom: 2rem;\n}\n\n.current-game-form h4 {\n  color: #2d3748;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-size: 1.2rem;\n}\n\n.complete-game-button {\n  width: 100%;\n  padding: 1rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1.5rem;\n}\n\n.complete-game-button.enabled {\n  background: #4299e1;\n  color: white;\n}\n\n.complete-game-button.enabled:hover {\n  background: #3182ce;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 15px rgba(66, 153, 225, 0.3);\n}\n\n.complete-game-button.disabled {\n  background: #e2e8f0;\n  color: #a0aec0;\n  cursor: not-allowed;\n}\n\n.match-complete {\n  text-align: center;\n  padding: 2rem;\n  background: linear-gradient(135deg, #c6f6d5, #9ae6b4);\n  border-radius: 12px;\n  border: 2px solid #48bb78;\n}\n\n.match-complete h4 {\n  color: #2f855a;\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n}\n\n.submit-match-button {\n  padding: 1rem 2rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: #48bb78;\n  color: white;\n}\n\n.submit-match-button:hover {\n  background: #38a169;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 15px rgba(72, 187, 120, 0.3);\n}\n\n.match-winner {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  background: linear-gradient(135deg, #ffd700, #ffed4e);\n  border-radius: 12px;\n  border: 2px solid #d69e2e;\n}\n\n.match-winner h4 {\n  color: #2d3748;\n  margin-bottom: 0.5rem;\n  font-size: 1.3rem;\n}\n\n.score-summary {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.games-results {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.game-result {\n  background: #f7fafc;\n  border-radius: 8px;\n  padding: 1.5rem;\n  border: 1px solid #e2e8f0;\n}\n\n.game-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.game-header strong {\n  color: #2d3748;\n  font-size: 1.1rem;\n}\n\n.game-winner {\n  color: #48bb78;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.half-results {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.half-result {\n  background: white;\n  padding: 1rem;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.half-result strong {\n  color: #2d3748;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n/* 順位表の更新 */\n.match-record-col, .game-record-col, .winrate-col {\n  text-align: center;\n}\n\n.asymmetric-standings-table .table-header {\n  grid-template-columns: 60px 1fr 100px 100px 100px 80px;\n}\n\n.asymmetric-standings-table .table-row {\n  grid-template-columns: 60px 1fr 100px 100px 100px 80px;\n}\n\n@media (max-width: 768px) {\n  .format-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .format-button {\n    width: 200px;\n  }\n  \n  .games-status {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .game-status {\n    width: 150px;\n  }\n  \n  .half-results {\n    grid-template-columns: 1fr;\n  }\n  \n  .asymmetric-standings-table .table-header,\n  .asymmetric-standings-table .table-row {\n    grid-template-columns: 40px 1fr 80px 80px 80px 60px;\n    gap: 0.25rem;\n    padding: 0.5rem;\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .app-header h1 {\n    font-size: 1.5rem;\n  }\n  \n  .section-header h2 {\n    font-size: 1.5rem;\n  }\n  \n  .champion-name {\n    font-size: 1.5rem;\n  }\n  \n  .champion-trophy {\n    font-size: 2rem;\n  }\n  \n  .half-match {\n    padding: 0.75rem;\n  }\n  \n  .team-name.hunter,\n  .team-name.survivor {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.9rem;\n  }\n  \n  .bo-result-form {\n    padding: 1rem;\n  }\n  \n  .current-game-form {\n    padding: 1rem;\n  }\n  \n  .games-progress {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
